var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GooglePlay"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.36577 0.31985C3.58332 -0.11262 2.66462 -0.10262 1.88716 0.3261L10.9992 8.7319L14.0602 5.67081L4.36577 0.31985ZM0.975957 1.18606C0.753467 1.54979 0.625977 1.96601 0.625977 2.40724V17.5889C0.625977 18.0164 0.742217 18.4239 0.952207 18.7801L10.1155 9.6168L0.975957 1.18606ZM18.1188 7.91069L15.1989 6.29952L11.9179 9.5793L15.9389 13.2879L18.12 12.0842C18.905 11.6492 19.375 10.8693 19.375 9.9968C19.3737 9.1244 18.905 8.3444 18.1188 7.91069ZM11.0342 10.4643L1.84591 19.6525C2.24464 19.88 2.68211 20 3.12209 20C3.54707 20 3.97454 19.8925 4.36577 19.6763L14.7865 13.9254L11.0342 10.4643Z",
    fill: "#F2F2F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayIcon);
export default __webpack_public_path__ + "static/media/googleplay_icon.9df4b532ed070b6c8dd2712bbd6fd3bf.svg";
export { ForwardRef as ReactComponent };